module.exports = __webpack_public_path__ + "static/media/fruit-orange-2.96225733.png";